module.exports = __webpack_public_path__ + "assets/img/kv-8d44772c.jpg";